var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5502 13.2573C29.4336 13.2406 29.3169 13.2406 29.2002 13.2573C26.6169 13.174 24.5669 11.0573 24.5669 8.45729C24.5669 5.80729 26.7169 3.64062 29.3836 3.64062C32.0336 3.64062 34.2002 5.79062 34.2002 8.45729C34.1836 11.0573 32.1336 13.174 29.5502 13.2573Z",
    fill: "#7B62FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9833 24.8073C33.1167 26.0573 30.5 26.524 28.0833 26.2073C28.7167 24.8406 29.05 23.324 29.0667 21.724C29.0667 20.0573 28.7 18.474 28 17.0906C30.4667 16.7573 33.0833 17.224 34.9667 18.474C37.6 20.2073 37.6 23.0573 34.9833 24.8073Z",
    fill: "#7B62FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0669 13.2573C11.1836 13.2406 11.3003 13.2406 11.4169 13.2573C14.0003 13.174 16.0503 11.0573 16.0503 8.45729C16.0503 5.79062 13.9003 3.64062 11.2336 3.64062C8.58359 3.64062 6.43359 5.79062 6.43359 8.45729C6.43359 11.0573 8.48359 13.174 11.0669 13.2573Z",
    fill: "#7B62FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2504 21.7243C11.2504 23.341 11.6004 24.8743 12.2337 26.2576C9.88369 26.5076 7.43369 26.0076 5.63369 24.8243C3.00036 23.0743 3.00036 20.2243 5.63369 18.4743C7.41702 17.2743 9.93369 16.791 12.3004 17.0576C11.617 18.4576 11.2504 20.041 11.2504 21.7243Z",
    fill: "#7B62FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5335 26.7576C20.4002 26.741 20.2502 26.741 20.1002 26.7576C17.0335 26.6576 14.5835 24.141 14.5835 21.041C14.6002 17.8743 17.1502 15.3076 20.3335 15.3076C23.5002 15.3076 26.0668 17.8743 26.0668 21.041C26.0502 24.141 23.6168 26.6576 20.5335 26.7576Z",
    fill: "#7B62FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.117 30.208C12.6003 31.8913 12.6003 34.658 15.117 36.3247C17.9837 38.2413 22.6837 38.2413 25.5503 36.3247C28.067 34.6413 28.067 31.8747 25.5503 30.208C22.7003 28.2913 18.0003 28.2913 15.117 30.208Z",
    fill: "#7B62FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup);
export default __webpack_public_path__ + "static/media/startup.394a8cc9bcef5bf50c024d473c4c0487.svg";
export { ForwardRef as ReactComponent };